import request from '@/services/interceptor.js'

/**
 * Recupera tutte le opzioni per le select del form ordine
 * @param {number|null} customerId - ID cliente per personalizzazioni (opzionale)
 * @returns {Promise} Oggetto con tutte le opzioni raggruppate per categoria
 */
export const get_opzioni = (customerId = null) => {
    return request({
        url: '/parametri/opzioni',
        method: 'get',
        params: customerId ? { customerId } : {},
        loadingBar: true
    })
}

/**
 * Recupera le opzioni per una specifica categoria
 * @param {string} categoria - Codice categoria (es: 'essenze', 'serie', ecc.)
 * @param {number|null} customerId - ID cliente per personalizzazioni (opzionale)
 * @returns {Promise} Array di opzioni { value, label }
 */
export const get_opzioni_by_categoria = (categoria, customerId = null) => {
    return request({
        url: `/parametri/opzioni/${categoria}`,
        method: 'get',
        params: customerId ? { customerId } : {},
        loadingBar: false
    })
}

/**
 * Recupera l'elenco delle categorie (per gestionale admin)
 * @returns {Promise} Array di categorie
 */
export const get_categorie = () => {
    return request({
        url: '/parametri/categorie',
        method: 'get',
        loadingBar: true
    })
}

/**
 * Recupera i valori di una categoria (per gestionale admin)
 * @param {number} categoriaId - ID della categoria
 * @param {number|null} customerId - ID cliente per personalizzazioni (opzionale)
 * @returns {Promise} Array di valori
 */
export const get_valori_by_categoria = (categoriaId, customerId = null) => {
    return request({
        url: `/parametri/valori/${categoriaId}`,
        method: 'get',
        params: customerId ? { customerId } : {},
        loadingBar: true
    })
}